import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import PropTypes from 'prop-types';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { useAltAllocationMessageContext } from 'Views/Page/Content/Modal/Layouts/AltAllocationMessage/AltAllocationMessageContext';
import { FDSecondaryActionButton } from '@facet-wealth/design';
import altAllocationMessageMetaOverride from './metaOverrideSet';
import altAllocationMessageLayout from './Layout';

export const AltAllocationMessageContainer = ({ relationship }) => {
  const {
    collection,
    fetchMessage,
    loading,
  } = useAltAllocationMessageContext();

  if (!relationship) {
    return null;
  }
  const handleOnClick = async () => {
    await fetchMessage(relationship);
  };

  const resource = collection?.resources()?.head();
  if (!resource) {
    return (
      <FDSecondaryActionButton
        label={'Get Alternative Income Allocation Information'}
        onClick={handleOnClick}
        loading={loading}
      />
    );
  }

  return (
    <DataContainer
      component={MetaResourceRenderer}
      componentProps={{
        LayoutProps: {},
        metaOverrideSet: altAllocationMessageMetaOverride,
        layout: altAllocationMessageLayout,
        resource,
      }}
      loading={loading || !resource}
    />
  );
};

AltAllocationMessageContainer.propTypes = {
  relationship: PropTypes.object.isRequired,
};
